import Vue from "vue";
import VueSSE from "vue-sse";

Vue.use(VueSSE);

export default VueSSE;
